import axios from "axios";
import qs from "qs";

export default {
  login(username, password) {
    var postData = {
      username: username,
      password: password,
      grant_type: "password",
      scope: process.env.CHAPTER_NUMBER
    };

    let axiosConfig = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Basic " + process.env.CLIENT_ID
      }
    };
    return axios
      .post("/auth/token", qs.stringify(postData), axiosConfig)
      .then(response => {
        return [response.data["access_token"], response.data["expires_in"]];
      })
      .catch(err => {
        console.log("AXIOS ERROR: ", err);
      });
  },
  checkLoggedIn(token) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token
      }
    };

    return axios
      .get("/auth/authorize", axiosConfig)
      .then(res => {
        if (res.status < 400) {
          return true;
        } else {
          return false;
        }
      })
      .catch(err => console.log("AXIOS ERROR: ", err));
  }
};



// WEBPACK FOOTER //
// ./src/utils/api/auth.js